import '../../../../vendor/hamsterjs/hamster.js';
import '../../../../vendor/angular-mousewheel/mousewheel.js';

export const mousewheelComponentModule = 'monospaced.mousewheel';
